import React,{useEffect, useState} from 'react';
import start from '../../../assets/img/gigs-imgs/star.svg';
import plusIcon from '../../../assets/img/event-imgs/e-plus.svg';
import './ClipVideos.css';
import { clipsData as clipsDataApi } from '../../../api';
import { Link } from 'react-router-dom';

const ClipVideos = () => {
    // Clips Video Cards Fetch Here
    const [ clipsVideosData, setClipsVideosData ] = useState([])
    useEffect( ()=>{
        clipsDataApi().then( data => setClipsVideosData(data))
    },[]) 
    console.log(clipsVideosData )
    return ( <div className='row gy-4'>
                {
                    clipsVideosData.map( (item ,index) =>  <div className="col-12 col-md-6 col-xxl-4" key={index}> 
                        <Link className="card linking-design" to={`/clips/details/${index}`}>
                            <div className="position-relative"><button className="btn btn-primary position-absolute rounded-circle d-flex justify-content-center align-items-center p-1" type="button" style={{backgroundColor: "#00000041",borderStyle: "none",right: "4%",bottom: "4%"}}>
                                    <img src={plusIcon} alt="" />
                                </button>
                                <img className="w-100" src={item.videoThumbanil} style={{borderRadius: "20px 20px 0px 0px"}} alt='' />
                                <div className="position-absolute px-2 rounded-pill d-flex justify-content-center align-items-center gap-1 l_wbadge"><span className="c_time">{item.videoHoure}</span></div>
                            </div>
                            <div className="w-100" style={{height: "4px",background: "linear-gradient(90deg, #B402F6, #40EEFE)"}}></div>
                            <div className="card-body">
                                <div className="row gap-2">
                                    <div className="col-12"><span className="txt_wa">{item.shortDesc}</span></div>
                                    <div className="col-12"><img className="me-1" src={item.authorIcon} alt=""  /><span className="txt_name">{item.authName}</span></div>
                                </div>
                            </div>
                            <div className="w-100" style={{height: "1px",background: "#3E3E3E"}}></div>
                            <div className="card-body">
                                <div className="row gap-2">
                                    <div className="col-12 d-flex justify-content-between align-items-center">
                                        <div className="d-flex justify-content-center align-items-center gap-1">
                                            <img src={start} alt="" />
                                            <span className="b_dt">{item.rating}</span>
                                            <span className="b_dt" style={{color: "#D1D1D1"}}>({item.ratingPeople})</span></div>
                                        <div><span className="txt_wa">${item.clipPrice}</span></div>
                                    </div>
                                </div>
                            </div>
                        </Link>
                </div> )
                }            
     </div>  );
};

export default ClipVideos;